function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
import './PaymentSubmit.css';
import React, { useState, useEffect, useRef } from 'react';
import { useHistory } from 'react-router-dom';
import { RichText, Text } from '@sitecore-jss/sitecore-jss-react';
import ActionsPanel from '../ActionsPanel';
import { isEmpty, sumBy } from 'lodash';
import { getDictionaryItem, get } from '../../../../utils';
import { IconWarning, IconAlert } from '../../../atoms/Icons/';
import { GetPaymentURL, GetFees, Search, PaymentValidation } from '../actions';
import Cookies from 'js-cookie';
const StepRender = props => {
  const history = useHistory();
  const {
    updateSteps,
    currentStepId,
    stepConfig,
    rtl,
    appRef,
    apiConfig,
    appn = '',
    applicationNumber = ''
  } = props;
  const frame = useRef();
  const [paymentTokken, setPaymentTokken] = useState('');
  const [, setTransactionToken] = useState('');
  const [data, setData] = useState({});
  const [fees, setFees] = useState([]);
  const [showFrame, setShowFrame] = useState(false);
  const [isRequesting, setIsRequesting] = useState(false);
  const [paymentUrl, setpPymentUrl] = useState('');
  const [errorServerMessage, setErrorServerMessage] = useState('');
  const paymentUrlRef = useRef('');
  const {
    data: {
      title,
      pSaShortDescription,
      buttonContinueUrl
    },
    dictionary,
    dictionaryNavigation
  } = stepConfig;
  const prevStepId = currentStepId - 1;
  const submitPageUrl = get(buttonContinueUrl, 'jss.value.href') || '/';
  const panelButtonState = {
    continue: {
      inactive: false,
      loading: isRequesting,
      label: getDictionaryItem(dictionaryNavigation, 'NavigationSubmit')
    },
    back: {
      inactive: false,
      label: getDictionaryItem(dictionaryNavigation, 'NavigationBack')
    },
    save: {
      inactive: true,
      label: getDictionaryItem(dictionaryNavigation, 'NavigationSave')
    }
  };
  const panelButtonFrameState = _objectSpread(_objectSpread({}, panelButtonState), {}, {
    continue: {
      inactive: !paymentTokken.length,
      loading: isRequesting,
      label: getDictionaryItem(dictionaryNavigation, 'NavigationSubmit')
    }
  });
  const panelActions = {
    contionueAction: async () => {
      setErrorServerMessage('');
      setIsRequesting(true);
      const {
        paymentUrl = '',
        error
      } = await GetPaymentURL(apiConfig, applicationNumber);
      setIsRequesting(false);
      if (!isEmpty(error)) {
        const errorMessage = rtl && error.ar ? error.ar : error.en || '';
        setErrorServerMessage(errorMessage.replaceAll(',', '\n'));
      }
      if (paymentUrl.length) {
        const params = new URL(paymentUrl).searchParams;
        const tokken = params.get('paymentRequestToken') || '';
        setpPymentUrl(paymentUrl);
        paymentUrlRef.current = paymentUrl;
        setTransactionToken(tokken || '');
        paymentUrl.length && setShowFrame(true);
      }
    },
    saveAction: async () => {},
    backAction: () => {
      setErrorServerMessage('');
      updateSteps(prevStepId);
    }
  };
  const panelActionsFrame = _objectSpread(_objectSpread({}, panelActions), {
    contionueAction: async () => {
      setErrorServerMessage('');
      setIsRequesting(true);
      const id = applicationNumber.length ? applicationNumber : appn;
      const {
        Success,
        error
      } = await PaymentValidation(apiConfig, {
        applicationNumber: id,
        NoqodiPaymentAuthResultAsJSONString: paymentTokken
      });
      setIsRequesting(false);
      if (!isEmpty(error)) {
        const errorMessage = rtl && error.ar ? error.ar : error.en || '';
        setErrorServerMessage(errorMessage.replaceAll(',', '\n'));
        return;
      }
      console.log(Success, error);
      if (Success) {
        Cookies.set('applicationNumber', id);
        history.push(submitPageUrl);
      }
    }
  });
  useEffect(() => {
    appRef && appRef.current.scrollIntoView({
      behavior: 'smooth'
    });
    async function fetchData(appnId) {
      const {
        applicationData,
        error
      } = await Search(apiConfig, appnId);
      setIsRequesting(false);
      if (!isEmpty(error)) {
        const errorMessage = rtl && error.ar ? error.ar : error.en || '';
        setErrorServerMessage(errorMessage.replaceAll(',', '\n'));
        return;
      }
      setData(applicationData);
    }
    async function fetchFees(appnId) {
      setIsRequesting(true);
      const {
        feesList,
        error
      } = await GetFees(apiConfig, appnId);
      setIsRequesting(false);
      if (!isEmpty(error)) {
        const errorMessage = rtl && error.ar ? error.ar : error.en || '';
        setErrorServerMessage(errorMessage.replaceAll(',', '\n'));
        return;
      }
      setFees(feesList);
    }
    if (applicationNumber.length || appn && appn.length) {
      const id = applicationNumber.length ? applicationNumber : appn;
      fetchData(id);
      fetchFees(id);
    } else {
      history.push(apiConfig.dashboardUrl);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const reloadFrame = message => {
    setShowFrame(false);
    setErrorServerMessage(message);
  };
  const getFrameData = e => {
    if (!paymentUrlRef.current.length) return;
    const parcedUrl = new URL(paymentUrlRef.current);
    const origin = parcedUrl && parcedUrl.origin;
    if (e.origin !== origin || !e.data) {
      return;
    }
    const responseJson = JSON.parse(e.data);
    if (responseJson && responseJson.statusInfo && responseJson.statusInfo.status && responseJson.statusInfo.status === 'SUCCESS') {
      setPaymentTokken(e.data.replaceAll('"', '%22') || '');
    } else {
      const message = responseJson.error && responseJson.error.statusInfo && responseJson.error.statusInfo.errorCode && responseJson.error.statusInfo.errorCode.message && responseJson.error.statusInfo.errorCode.message || responseJson.statusText;
      reloadFrame(message || '');
    }
    //
  };
  useEffect(() => {
    if (!window) return;
    window.addEventListener('message', getFrameData, false);
    return () => {
      window.removeEventListener('message', getFrameData);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return /*#__PURE__*/React.createElement("div", {
    className: ` ${commonStyles} ${rtl ? rtlStyles : ltrStyles}`
  }, /*#__PURE__*/React.createElement("div", {
    className: "wizard__body"
  }, /*#__PURE__*/React.createElement("div", {
    className: "module-header"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row "
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-md-12"
  }, /*#__PURE__*/React.createElement("div", {
    className: ""
  }, /*#__PURE__*/React.createElement(Text, {
    tag: "h2",
    className: 'h2',
    field: title || {
      value: ''
    }
  }), /*#__PURE__*/React.createElement(RichText, {
    className: "description",
    field: get(pSaShortDescription, 'jss')
  }))))), showFrame ? /*#__PURE__*/React.createElement("div", {
    className: "module-group-app"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-md-12"
  }, /*#__PURE__*/React.createElement("iframe", {
    ref: frame,
    src: paymentUrl,
    className: "iframe",
    title: "payment-frame"
  }))), errorServerMessage.length ? /*#__PURE__*/React.createElement("div", {
    className: "error-message"
  }, errorServerMessage) : '') : /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "module-group-app module-group-app--inside"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row no-indent"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-lg-4 col-md-6 header-table"
  }, /*#__PURE__*/React.createElement("p", {
    className: "header-table__name"
  }, getDictionaryItem(dictionary, 'ApplicantName')), /*#__PURE__*/React.createElement("p", {
    className: "header-table__value"
  }, data && data.ApplicantName && (rtl ? data.ApplicantName.AR : data.ApplicantName.EN))), /*#__PURE__*/React.createElement("div", {
    className: "col-lg-4 col-md-6 header-table"
  }, /*#__PURE__*/React.createElement("p", {
    className: "header-table__name"
  }, getDictionaryItem(dictionary, 'ApplicationNumber')), /*#__PURE__*/React.createElement("p", {
    className: "header-table__value"
  }, applicationNumber))), /*#__PURE__*/React.createElement("div", {
    className: "row "
  }, /*#__PURE__*/React.createElement("div", {
    className: "table-chart col-md-12"
  }, /*#__PURE__*/React.createElement("table", {
    className: 'table-chart__table'
  }, /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", null, getDictionaryItem(dictionary, 'Type')), /*#__PURE__*/React.createElement("th", null, getDictionaryItem(dictionary, 'FeeAmount')))), /*#__PURE__*/React.createElement("tbody", null, fees.map((_ref, index) => {
    let {
      amount,
      nameEn,
      nameAr
    } = _ref;
    const title = rtl ? nameAr : nameEn;
    return /*#__PURE__*/React.createElement("tr", {
      key: index
    }, /*#__PURE__*/React.createElement("td", null, title), /*#__PURE__*/React.createElement("td", null, amount));
  }), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
    colSpan: 2,
    className: "result"
  }, /*#__PURE__*/React.createElement("div", {
    className: "result-wrapper"
  }, /*#__PURE__*/React.createElement("span", null, " ", getDictionaryItem(dictionary, 'total') || 'TOTAL', " :"), /*#__PURE__*/React.createElement("span", {
    className: "result__count"
  }, sumBy(fees, _ref2 => {
    let {
      amount
    } = _ref2;
    return amount;
  })), /*#__PURE__*/React.createElement("span", null, " ", getDictionaryItem(dictionary, 'AED') || 'AED')))))))), errorServerMessage.length ? /*#__PURE__*/React.createElement("div", {
    className: "error-message"
  }, errorServerMessage) : ''), /*#__PURE__*/React.createElement("div", {
    className: ""
  }, /*#__PURE__*/React.createElement("p", {
    className: "alert-box"
  }, /*#__PURE__*/React.createElement(IconAlert, null), getDictionaryItem(dictionary, 'PaymentSubmitApplicationAlert')), /*#__PURE__*/React.createElement("p", {
    className: "info-box module-group-wrap"
  }, /*#__PURE__*/React.createElement(IconWarning, null), getDictionaryItem(dictionary, 'PaymentSubmitApplicationMessage'))))), showFrame ? /*#__PURE__*/React.createElement(ActionsPanel, {
    rtl: rtl,
    actions: panelActionsFrame,
    buttonState: panelButtonFrameState
  }) : /*#__PURE__*/React.createElement(ActionsPanel, {
    rtl: rtl,
    actions: panelActions,
    buttonState: panelButtonState
  }));
};
const commonStyles = "c1aajxvm";
const rtlStyles = "reivnau";
const ltrStyles = "l1n43fc5";
export default StepRender;